/** Canonical overview scope ids and labels for resource list pages. */
export const RESOURCE_OVERVIEW_SCOPES = {
  databases: { scopeId: "databases", scopeLabel: "Tables" },
  boards: { scopeId: "boards", scopeLabel: "Boards" },
  teams: { scopeId: "teams", scopeLabel: "Teams" },
  artifacts: { scopeId: "artifacts", scopeLabel: "Artifacts" },
  docs: { scopeId: "docs", scopeLabel: "Docs" },
  agents: { scopeId: "agents", scopeLabel: "Agents" },
  files: { scopeId: "files", scopeLabel: "Files" },
  custom_functions: { scopeId: "custom_functions", scopeLabel: "Custom Functions" },
};

export const OVERVIEW_SCOPE_IDS = new Set(
  Object.values(RESOURCE_OVERVIEW_SCOPES).map((scope) => scope.scopeId)
);

export const OVERVIEW_SCOPE_LABELS = new Set(
  Object.values(RESOURCE_OVERVIEW_SCOPES).map((scope) => scope.scopeLabel)
);

export function getResourceOverviewScope(scopeKey) {
  return RESOURCE_OVERVIEW_SCOPES[scopeKey] ?? null;
}
